export const TaskReminderFrequencyEnum = {
    DAILY: {
        key: 1,
        value: 'daily',
    },
    WEEKLY: {
        key: 2,
        value: 'weekly'
    },
    MONTHLY: {
        key: 3,
        value: 'monthly'
    }
}